import { Rating, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SessionSummaryFieldsFragment, useUpdateSessionMutation } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import withSessionDetailsSectionErrorBoundary from '../SessionDetailsSectionErrorBoundary';
import useUpdateSession from '../SessionNote/useUpdateSession';
import StyledBox from './styles';

interface SessionScoreProps {
  session: SessionSummaryFieldsFragment;
}

function SessionScore(props: SessionScoreProps) {
  const { session } = props;
  const { t } = useTranslation('session');

  const updateSession = useUpdateSession();
  const updateNote = useUpdateSessionMutation({
    onSuccess(data) {
      updateSession(data.session.update);
    },
  });
  return (
    <StyledBox>
      <Typography variant="subtitle1">
        {t('details.score')}
      </Typography>
      <Rating
        defaultValue={(session.score * 5)}
        precision={0.5}
        onChange={(event, newValue) => {
          updateNote.mutate({
            input: {
              id: session.id,
              score: (newValue / 5),
            },
          });
        }}
      />
    </StyledBox>
  );
}

export default withSessionDetailsSectionErrorBoundary(SessionScore, 'session score');
